import React, { Component } from "react";

class SignoutInteractive extends Component {
  async componentDidMount() {
    window.opener.location.reload();
    window.opener.location.replace(window.location.origin + "/signin");
    window.close();
  }

  render() {
    return <></>;
  }
}
export default SignoutInteractive;
